// extracted by mini-css-extract-plugin
export var bodyContent = "styles-module--bodyContent--d35d4";
export var description = "styles-module--description--6c4be";
export var descriptionLight = "styles-module--descriptionLight--5fcad";
export var heroBannerParagraphDesktop = "styles-module--hero-banner-paragraph-desktop--b1b70";
export var heroBannerParagraphMobile = "styles-module--hero-banner-paragraph-mobile--c0991";